// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CreditCardList-styles___pageHeaderWrapper--QsDeM {
  display: flex;
  justify-content: space-between;
}

.components-CreditCardList-styles___clickable--O1pWk {
  cursor: pointer;
}

.components-CreditCardList-styles___tableHead--WSwGh {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-CreditCardList-styles___tableRow--tiAOF:last-child .components-CreditCardList-styles___tableRowCell--_gCSc {
      border: none;
    }

.components-CreditCardList-styles___tableRow--tiAOF:hover {
    background: #f6f6f7;
  }

.components-CreditCardList-styles___paper--EA8Q2 {
  position: relative;
}

.components-CreditCardList-styles___tableRowCell--_gCSc {
  padding: 4px 24px 4px 24px !important;
  font-size: 15px !important;
  max-width: 220px !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

.components-CreditCardList-styles___tableRowCellEmail--AOF4x {
  max-width: 300px !important;
}

.components-CreditCardList-styles___tableRowCellBirthDate--SmMpI {
  max-width: 70px !important;
}

.components-CreditCardList-styles___clickable--O1pWk {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./components/CreditCardList/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAII;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".pageHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  &:last-child {\n    .tableRowCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.paper {\n  position: relative;\n}\n\n.tableRowCell {\n  padding: 4px 24px 4px 24px !important;\n  font-size: 15px !important;\n  max-width: 220px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tableRowCellEmail {\n  max-width: 300px !important;\n}\n\n.tableRowCellBirthDate {\n  max-width: 70px !important;\n}\n\n.clickable {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeaderWrapper": `components-CreditCardList-styles___pageHeaderWrapper--QsDeM`,
	"clickable": `components-CreditCardList-styles___clickable--O1pWk`,
	"tableHead": `components-CreditCardList-styles___tableHead--WSwGh`,
	"tableRow": `components-CreditCardList-styles___tableRow--tiAOF`,
	"tableRowCell": `components-CreditCardList-styles___tableRowCell--_gCSc`,
	"paper": `components-CreditCardList-styles___paper--EA8Q2`,
	"tableRowCellEmail": `components-CreditCardList-styles___tableRowCellEmail--AOF4x`,
	"tableRowCellBirthDate": `components-CreditCardList-styles___tableRowCellBirthDate--SmMpI`
};
module.exports = ___CSS_LOADER_EXPORT___;
